import React from 'react';
import moment from 'moment';

import {
  GROUPED_CONTENT_TYPES,
  CONTENT_TYPE_DOWNLOAD,
} from '../../config/constants';

import './style.scss';

const InfoHeading = ({ entity }) => {
  const type = entity.getIn(['type', 0, 'target_id']);
  const date = entity.getIn(['created', 0, 'value'], '');
  const firstThemeName = entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], null);
  const readTimeMinutes = entity.getIn(['field_read_time', 0, 'minutes'], null);
  const readTimeSeconds = entity.getIn(['field_read_time', 0, 'seconds'], null);
  let readTime = null;

  // Round up the reading time.
  if (readTimeMinutes && readTimeSeconds) {
    readTime = readTimeMinutes;
    if (readTimeSeconds > 0) readTime += 1;
  }

  return (
    <div className="InfoHeading">

      {/* Theme */}
      {firstThemeName && (
        <div className="InfoHeading__theme InfoHeading__item theme-label">
          {firstThemeName}
        </div>
      )}

      {/* Type */}
      <div className="InfoHeading__item InfoHeading__type">
        {GROUPED_CONTENT_TYPES[type]}
      </div>

      {/* Date */}
      <div className="InfoHeading__item InfoHeading__date">
        <span className="icon-divider">
          <i className="icon icon-asterisk icon-variant-1" />
        </span>
        <span>{moment(date).format('DD MMMM YYYY')}</span>
      </div>

      {/* ReadTime */}
      {(readTime && type !== CONTENT_TYPE_DOWNLOAD) && (
        <div className="InfoHeading__item InfoHeading__readtime">
          <span className="icon-divider">
            <i className="icon icon-asterisk icon-variant-1" />
          </span>
          <span>Leestijd {readTime} min.</span>
        </div>
      )}

    </div>
  );
};

export default InfoHeading;
